import urlJson from "../config/url.json"
import axios from "axios";
import store from "../store";

axios.interceptors.request.use(config => {    // 这里的config包含每次请求的内容
  config.headers['x-quantdata-auth-timestamp'] = localStorage.getItem('x-quantdata-auth-timestamp')
  config.headers['x-quantdata-auth-id'] = localStorage.getItem('x-quantdata-auth-id')
  config.headers['x-quantdata-auth-token'] = localStorage.getItem('x-quantdata-auth-token')
  config.headers['x-quantdata-auth-client-id'] = localStorage.getItem('x-quantdata-auth-client-id');
  // config.headers['access-control-allow-origin'] = '*'
  return config;
}, function (err) {
  return Promise.reject(err);
})
//拦截器
axios.interceptors.response.use(
  response => {
    if(response.headers['x-quantdata-auth-token'])
      localStorage.setItem('x-quantdata-auth-token', response.headers['x-quantdata-auth-token'])
    if(response.headers['x-quantdata-auth-timestamp'])
      localStorage.setItem('x-quantdata-auth-timestamp', response.headers['x-quantdata-auth-timestamp'])
    if(response.headers['x-quantdata-auth-id'])
      localStorage.setItem('x-quantdata-auth-id', response.headers['x-quantdata-auth-id'])
    if(response.headers['x-quantdata-auth-client-id'])
      localStorage.setItem('x-quantdata-auth-client-id', response.headers['x-quantdata-auth-client-id'])
    return response
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          localStorage.setItem('x-quantdata-auth-token', null)
          localStorage.setItem('x-quantdata-auth-timestamp', null)
          localStorage.setItem('x-quantdata-auth-id', null)
          window.location.href = '/login'
          alert(error.response.data.message)
          return
        case 429:
        // 返回 401 清除token信息并跳转到登录页面
          alert(error.response.data.message)
          return
        case 403:
          store.commit('limits/setIsShowMask', true)
          const arr = window.location.href.split('/')
          if (arr[arr.length - 1] === 'home') {
            store.commit('limits/setIsShowMask', false)
          }
          return Promise.reject(error)
        default:
          console.log(error)
      }
    } else {
      // localStorage.setItem('x-quantdata-auth-token', null)
      // localStorage.setItem('x-quantdata-auth-timestamp', null)
      // localStorage.setItem('x-quantdata-auth-id', null)
      // window.location.href = '/login'
      console.log(error)
    }
    return Promise.reject(error)   // 返回接口返回的错误信息
  })
const urlManager = (urlId) => {
  let url = urlJson.urls[urlId]
  return {
    url: url['url'].replace('{contentDomain}', urlJson.contentDomain).replace('{contentVersion}', url.contentVersion),
    method: url['method'],
    get: 'get',
    post: 'post',
    put: 'put',
    delete: 'delete'
  }
}

const httpManager = (urlId, params, body, config, pathVars) => {
  let http = urlManager(urlId)
  if (pathVars != null) {
    for (let [key, value] of pathVars) {
      http.url = http.url.replace('{'+key+'}', value)
    }
  }
  let p = ""
  if (params != null) {
    for (let [key, value] of params) {
      if (p.indexOf("?") == -1) {
        p += "?"
      } else {
        p += "&"
      }
      p += key + "=" + value
    }
  }
  if (!config) {
    config = {
      headers: {}
    }
  }
  let url = http.url + p
  if (http.method == http.get) {
    return axios.get(url, config)
  }
  if (http.method == http.delete) {
    return axios.delete(url, config)
  }
  if (http.method == http.post) {
    return axios.post(url, body, config)
  }
  if (http.method == http.put) {
    return axios.put(url, body, config)
  }
}
export default httpManager



// WEBPACK FOOTER //
// ./src/util/common.js